import { createStyles } from "@mantine/core"
import * as constants from "app/static/frontend/design-constants"

export const useStyles = createStyles((theme) => ({
    urlText: {
        borderLeft: `4px solid ${constants.HeaderColor}`,
        paddingLeft: `11px`,
        width: "100%",

        [theme.fn.largerThan("xs")]: {
            width: "50%",
        },
    },
}))
